"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccommodationBedding = void 0;
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
class AccommodationBedding extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.duvets) && this.duvets >= 0
            && utils_1.Guard.isNotNullish(this.duvetCovers) && this.duvetCovers >= 0
            && utils_1.Guard.isNotNullish(this.pillows) && this.pillows >= 0
            && utils_1.Guard.isNotNullish(this.pillowCases) && this.pillowCases >= 0
            && utils_1.Guard.isNotNullish(this.bedSheets) && this.bedSheets >= 0
            && utils_1.Guard.isNotNullish(this.towels) && this.towels >= 0);
    }
    toPlain() {
        return { ...this };
    }
}
exports.AccommodationBedding = AccommodationBedding;
//# sourceMappingURL=AccommodationBedding.js.map